export { default as LocalImage, type LocalImageProps } from './LocalImage';
